// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1d1Li","col":"styles_col__1jg3H"};